// @ts-nocheck

import React, { useEffect } from 'react';

import MenuDesktopContainer from '../components/MenuDesktop/MenuDesktopContainer';
import PageSelectTab from '../components/PageSelectTab';
import useRouter from '../hooks/useRouter';
import { RoutePatterns } from '../types/routes';
import RoutesRedirectionFactory from '../utils/routes/RoutesRedirectionFactory';

const HomeRedirection = () => {
  const { history } = useRouter();

  useEffect(() => {
    if (history) {
      history.push(RoutesRedirectionFactory.getHomeRouteConfig());
    }
  }, [history]);

  return null;
};

/**
 * Regroups all the necessary routes for the betting section
 */
const routes = [
  {
    pattern: RoutePatterns.HOME,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab />,
    exact: true,
  },
  {
    pattern: RoutePatterns.LIVE,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab tab="live" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.CALENDAR,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab tab="calendar" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.CATALOG,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab />,
    exact: true,
  },
  {
    pattern: RoutePatterns.FAVORITES,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab />,
    exact: true,
  },
  {
    pattern: RoutePatterns.MATCH,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: false,
  },
  {
    pattern: RoutePatterns.LINE_UP,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: true,
  },
  {
    pattern: RoutePatterns.BETBUILDER,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: true,
  },
  {
    pattern: RoutePatterns.MATCH_AND_BASKETITEM,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab />,
    exact: true,
  },
  {
    pattern: RoutePatterns.MULTIVIEW,
    Menu: () => null, // We don't want left menu
    Tab: () => <PageSelectTab tab="multiplex" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.HISTORY,
    Menu: MenuDesktopContainer,
    Tab: () => <PageSelectTab tab="history" />,
    exact: true,
  },
  {
    pattern: RoutePatterns.EXTRAS,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: true,
  },
  {
    pattern: RoutePatterns.KL,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: false,
  },
  {
    pattern: RoutePatterns.MP,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: false,
  },
  {
    pattern: RoutePatterns.GR,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: false,
  },
  {
    pattern: RoutePatterns.BOOM,
    Menu: MenuDesktopContainer,
    Tab: PageSelectTab,
    exact: false,
  },
  {
    pattern: undefined,
    Menu: () => <HomeRedirection />,
    Tab: () => <PageSelectTab />,
    exact: false,
  },
];

export default routes;
